export default {
  // Header & navigation
  'header.eyebrow': 'Online narudžba',
  'nav.info': 'Informacije',
  'nav.cart': 'Košarica',
  'nav.menu': 'Jelovnik',

  // Menu
  'menu.loading': 'Učitavanje jelovnika...',
  'menu.error': 'Greška pri učitavanju jelovnika:',
  'menu.empty': 'Nema dostupnih stavki.',

  // Cart
  'cart.title': 'Košarica',
  'cart.empty': 'Košarica je prazna.',
  'cart.total': 'Ukupno',
  'cart.checkout': 'Nastavi na plaćanje',
  'cart.back': 'Natrag na jelovnik',
  'cart.fab': 'Košarica ({count}) — {total} €',
  'cart.view': 'Košarica',

  // Complement picker
  'picker.selectMultiple': '(odaberi više)',
  'picker.selectOne': '(odaberi jedno)',
  'picker.addToCart': 'Dodaj u košaricu',
  'picker.note': 'Napomena za ovu stavku',
  'picker.notePlaceholder': 'npr. bez luka, extra umak...',
  'picker.quantity': 'Količina',

  // Checkout
  'checkout.title': 'Narudžba',
  'checkout.back': 'Natrag',
  'checkout.timingTitle': 'Vrijeme dostave',
  'checkout.timingAsap': 'Što prije moguće',
  'checkout.timingScheduled': 'Zakaži za određeno vrijeme',
  'checkout.scheduleDate': 'Datum',
  'checkout.scheduleTime': 'Vrijeme',
  'checkout.scheduleHint': 'Najmanje 1 sat unaprijed, unutar radnog vremena.',
  'checkout.scheduleRequired': 'Odaberite datum i vrijeme dostave.',
  'checkout.scheduleNoSlots': 'Nema dostupnih termina za odabrani datum.',
  'checkout.scheduleNoDays': 'Trenutno nema otvorenih dana za zakazivanje.',
  'step.contact': 'Kontakt podaci',
  'step.timing': 'Vrijeme dostave',
  'step.payment': 'Način plaćanja',
  'step.next': 'Dalje',
  'checkout.name': 'Ime i prezime',
  'checkout.address': 'Adresa dostave',
  'checkout.floor': 'Kat / stan',
  'checkout.phone': 'Telefon',
  'checkout.email': 'E-mail adresa',
  'checkout.emailInvalid': 'Unesite ispravnu e-mail adresu.',
  'checkout.note': 'Napomena za narudžbu',
  'checkout.submit': 'Naruči',
  'checkout.submitting': 'Šaljem narudžbu...',
  'checkout.items': 'Stavke',
  'checkout.deliveryFee': 'Dostava',
  'checkout.total': 'Ukupno',
  'checkout.free': 'Besplatno',
  'checkout.fillRequired': 'Molimo ispunite sva obavezna polja.',
  'checkout.noLocation': 'Nije konfigurirana lokacija za dostavu. Kontaktirajte restoran.',
  'checkout.paymentCash': 'Gotovina',
  'checkout.paymentCard': 'Kartica',
  'checkout.minimumOrder': 'Minimalni iznos narudžbe za zonu "{zone}" je {min} €. Vaša narudžba: {amount} €.',

  // Order status
  'status.pending': 'Vaša narudžba je zaprimljena. Čekamo potvrdu...',
  'status.pendingDelayed': 'Vaša zakazana narudžba za {when} je zaprimljena.',
  'status.pendingDelayedEmail': 'Restoran će je pregledati prije isporuke i poslat ćemo Vam potvrdu na e-mail.',
  'status.approved': 'Narudžba odobrena!',
  'status.approvedEta': 'Procijenjeno vrijeme dostave: ~{minutes} min',
  'status.approvedDelayed': 'Zakazana dostava: {when}. Dat ćemo sve od sebe da je isporučimo u zakazanom terminu.',
  'status.rejected': 'Narudžba odbijena.',
  'status.rejectedReason': 'Razlog: {reason}',
  'status.newOrder': 'Nova narudžba',

  // Closed overlay / banner
  'closed.title': 'Zatvoreno',
  'closed.paused': 'Žao nam je, trenutno nije moguće naručiti online.',
  'closed.outsideHours': 'Online narudžbe trenutno nisu dostupne.',
  'closed.schedule': 'Radno vrijeme',
  'banner.closed': 'Restoran je trenutno zatvoren. Možete pregledati jelovnik ili zakazati narudžbu za kasnije.',
  'banner.paused': 'Trenutno smo zauzeti i privremeno ne primamo ASAP narudžbe. Možete zakazati narudžbu za kasnije.',

  // Info page
  'info.title': 'Informacije',
  'info.deliveryZones': 'Zone dostave',
  'info.zoneMin': 'Min',
  'info.zoneFee': 'Dostava',
  'info.zoneFree': 'Besplatno',
  'info.openingHours': 'Radno vrijeme',
  'info.deliveryHours': 'Radno vrijeme dostave',
  'info.pickupHours': 'Radno vrijeme preuzimanja',
  'info.paymentMethods': 'Načini plaćanja',
  'info.address': 'Adresa',
  'info.phone': 'Telefon',
  'info.languages': 'Jezik',
  'info.back': 'Natrag',

  // Reservation
  'reservation.title': 'Rezervacija stola',
  'reservation.notAccepting': 'Trenutno ne primamo rezervacije.',
  'reservation.guests': 'Broj osoba',
  'reservation.guestsPlaceholder': 'Odaberi broj osoba',
  'reservation.date': 'Datum',
  'reservation.time': 'Vrijeme',
  'reservation.name': 'Ime i prezime',
  'reservation.phone': 'Telefon',
  'reservation.note': 'Napomena',
  'reservation.notePlaceholder': 'dodatne napomene (neobavezno)',
  'reservation.submit': 'Rezerviraj',
  'reservation.submitting': 'Slanje...',
  'reservation.fillRequired': 'Molimo ispunite sva obavezna polja.',
  'reservation.pending': 'Vaš zahtjev je zaprimljen. Čekamo potvrdu...',
  'reservation.approved': 'Rezervacija potvrđena!',
  'reservation.rejected': 'Rezervacija odbijena.',

  // Delivery time notice
  'delivery.minTime': 'Trenutno minimalno vrijeme dostave: ~{minutes} min',

  // Days
  'day.0': 'Ponedjeljak',
  'day.1': 'Utorak',
  'day.2': 'Srijeda',
  'day.3': 'Četvrtak',
  'day.4': 'Petak',
  'day.5': 'Subota',
  'day.6': 'Nedjelja',
} as const;
